module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (168).d8876a25.jpg";